import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '../../client-api';
import { type BalanceSheetResponse, getBalanceSheet, reloadMaturities } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useBalanceSheet(): UseQueryResult<BalanceSheetResponse, Error> {
    const { data: client } = useClient();
    const queryKey = queryKeys.balanceSheet(client?.partnerUuid);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => {
            // Side effect for reloading maturities
            reloadMaturities({ path: { clientId: client!.id } });

            return getBalanceSheet({ path: { partnerUuid: client!.partnerUuid }, signal }).then((result) => result.data!);
        },
        enabled: !!client,
    });
}
